import { TFunction } from 'i18next'

import { EInvoiceAddressSchemeType } from '../../../enums/eInvoiceAddressSchemeType'
import { EInvoiceScheme } from '../../../types/eInvoiceScheme'

export const eInvoiceAddressPlaceholders: Record<EInvoiceAddressSchemeType, string> = {
  [EInvoiceAddressSchemeType.CUSTOM]: 'customer_modal.form.e_invoice_address_placeholder.CUSTOM',
  [EInvoiceAddressSchemeType.DUNS]: 'customer_modal.form.e_invoice_address_placeholder.DUNS',
  [EInvoiceAddressSchemeType.GLN]: 'customer_modal.form.e_invoice_address_placeholder.GLN',
  [EInvoiceAddressSchemeType.GOV]: 'customer_modal.form.e_invoice_address_placeholder.GOV',
  [EInvoiceAddressSchemeType.IBAN]: 'customer_modal.form.e_invoice_address_placeholder.IBAN',
  [EInvoiceAddressSchemeType.KUR]: 'customer_modal.form.e_invoice_address_placeholder.KUR',
  [EInvoiceAddressSchemeType.LWID]: 'customer_modal.form.e_invoice_address_placeholder.LWID',
  [EInvoiceAddressSchemeType.OIN]: 'customer_modal.form.e_invoice_address_placeholder.OIN',
  [EInvoiceAddressSchemeType.OINO]: 'customer_modal.form.e_invoice_address_placeholder.OINO',
  [EInvoiceAddressSchemeType.ORGNR]: 'customer_modal.form.e_invoice_address_placeholder.ORGNR',
  [EInvoiceAddressSchemeType.OVT]: 'customer_modal.form.e_invoice_address_placeholder.OVT',
  [EInvoiceAddressSchemeType.SIRENE]: 'customer_modal.form.e_invoice_address_placeholder.SIRENE',
  [EInvoiceAddressSchemeType.VAT]: 'customer_modal.form.e_invoice_address_placeholder.VAT',
}

export const getEInvoiceAddressPlaceholder = (
  t: TFunction,
  scheme: EInvoiceScheme,
  isUnsupportedEInvoiceAddressType?: boolean,
) => {
  if (isUnsupportedEInvoiceAddressType) {
    return t('customer_modal.form.e_invoice_address.SIRENE.placeholder.coming_soon')
  }

  const schemeKey = scheme && eInvoiceAddressPlaceholders[scheme]

  return t(schemeKey ?? eInvoiceAddressPlaceholders.CUSTOM)
}
